import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Search = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='m20.25 20.25-4.123-4.123m0 0A7.25 7.25 0 1 0 5.874 5.874a7.25 7.25 0 0 0 10.253 10.253'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <>
        <path d='M11 16a5 5 0 1 0 0-10 5 5 0 0 0 0 10' fill='currentColor' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11 4.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M3 11a8 8 0 1 1 14.162 5.102l3.618 3.618a.75.75 0 1 1-1.06 1.06l-3.618-3.618A8 8 0 0 1 3 11'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
